import { logger, LogLevel } from '@plug-core/logger'
import * as Sentry from '@sentry/browser'
import { version } from '../../../package.json'

const IGNORED_ERRORS: string[] = []

export const initializeSentry = () => {
  if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
    try {
      Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.8,
        release: version,
        ignoreErrors: IGNORED_ERRORS,
      })

      logger.addTransport((level, message, extra) => {
        if (level === LogLevel.Error) {
          const err = typeof message === 'string' ? new Error(message) : message

          Sentry.captureException(err, { extra })
        } else {
          Sentry.captureMessage(message.toString(), { extra })
        }
      })
    } catch (e) {
      logger.debug('Sentry failed to initialize', { originalError: e })
    }
  }
}
